import axios from 'axios';
import {
	Loading,
	Message,
	MessageBox
} from 'element-ui';
// const baseUrl = 'http://192.168.0.18:8068/';
const baseUrl = 'https://serverapi.xiaohuoxia.com/';

let loadingInstance;

// 请求拦截器
axios.interceptors.request.use(config => {
	const token = localStorage.getItem('token')
	config.headers['token'] = token
	if(config.url.indexOf('app/caporder/export')>=0 || config.url.indexOf('app/cborder/export')>=0 || config.url.indexOf('app/capbillway/bill')>=0 || config.url.indexOf('app/capbillwork/bill')>=0 || config.url.indexOf('app/capuserdetails/export')>=0 || config.url.indexOf('app/cbordergoods/export')>=0 || config.url.indexOf('app/cborder/exportAll')>=0 || config.url.indexOf('app/capordergoods/export')>=0){
		config.headers['Content-Type'] = 'application/json;charset=utf-8'
		config['responseType'] = 'blob'
	}


	// 显示加载动画
	loadingInstance = Loading.service({
		fullscreen: true
	});
	return config;
}, error => {
	// 处理请求错误
	return Promise.reject(error);
});

// 响应拦截器
axios.interceptors.response.use(response => {
	// 关闭加载动画
	if (loadingInstance) loadingInstance.close();
	if(response.config.url.indexOf('app/caporder/export')>=0 || response.config.url.indexOf('app/cborder/export')>=0 || response.config.url.indexOf('app/capbillway/bill')>=0 || response.config.url.indexOf('app/capbillwork/bill')>=0 || response.config.url.indexOf('app/capuserdetails/export')>=0 || response.config.url.indexOf('app/cbordergoods/export')>=0 || response.config.url.indexOf('app/cborder/exportAll')>=0 || response.config.url.indexOf('app/capordergoods/export')>=0){
		return response
	}
	
	if (response.data.code == 200) {
		return response.data
	} else if (response.data.code == 401) {
		MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
			confirmButtonText: '重新登录',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			console.info(88888)
			// this.$router.push('/login')
			location.href = '/login'
		})
	} else {
		if ((response.config.url.indexOf('app/caporder/export') >= 0 || response.config.url.indexOf('app/cborder/export')>=0) && response.status == 200) {
			return response.data
		} else {
			Message({
				message: response.data.msg,
				type: 'error'
			})
		}
	}
}, error => {
	// 关闭加载动画
	if (loadingInstance) loadingInstance.close();
	// 处理响应错误
	Message({
		message: error.data.msg,
		type: 'error'
	})
	// return Promise.reject(error);
});

export default {
	get(url, params) {
		return axios.get(baseUrl + url, {
			params
		});
	},
	post(url, data) {
		return axios.post(baseUrl + url, data);
	},
	// 可以根据需要添加其他HTTP方法的封装
};


// WEBPACK FOOTER //
// ./src/utils/request.js